import { render, staticRenderFns } from "./ChartMyContributions.vue?vue&type=template&id=c3157afc&"
import script from "./ChartMyContributions.vue?vue&type=script&lang=ts&"
export * from "./ChartMyContributions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports